var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2.5,
    fill: "url(#paint0_linear_176_2854)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5571 14.1305H16.4177V5.21655H11.5571V14.1305Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8754 9.62939C11.8754 7.83512 12.7063 6.23718 14 5.20711C13.0537 4.45376 11.8599 4.00439 10.5623 4.00439C7.49026 4.00439 5 6.52294 5 9.62939C5 12.7359 7.49026 15.2544 10.5623 15.2544C11.8599 15.2544 13.0537 14.805 14 14.0517C12.7063 13.0217 11.8754 11.4237 11.8754 9.62939Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9878 9.62921C22.9878 12.7361 20.4974 15.2544 17.4253 15.2544C16.1276 15.2544 14.9338 14.805 13.9878 14.0516C15.2815 13.022 16.1121 11.4236 16.1121 9.62921C16.1121 7.83488 15.2815 6.23688 13.9878 5.20678C14.9338 4.45378 16.1276 4.00439 17.4253 4.00439C20.4974 4.00439 22.9878 6.52265 22.9878 9.62921Z",
    fill: "#F79E1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_176_2854",
    x1: -14,
    y1: 10,
    x2: 4.91892,
    y2: 36.4865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606078,
    stopColor: "#EEEAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE7DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master_card.5ec36a81.svg";
export { ForwardRef as ReactComponent };